
const parseGRS = (response) => {
  if (response && typeof response === "object") {
    return response; // Already an object, return as is
  }
  
  if (typeof response === "string") {
    try {
      return JSON.parse(response);
    } catch (error) {
      console.error("Invalid JSON response:", error);
      return null; // Handle the error gracefully
    }
  }

  return null; // Handle unexpected cases
}

const remapData = (data) => {
  const { facets, products, resultCount, page, attributionToken, sortOptions, selectedSort, searchQuery, grsRequest } = data;
  const sortBy = sortOptions.find((sort) => sort.value == selectedSort);
  const query = searchQuery?.productSearchQuery?.searchParameters?.keywords;
  const filters = facets.reduce((acc, group) => {
    group.values.forEach((value) => {
      if (value.selected) {
        // find the index for the existing group inside the loop
        const existingGroupIndex = acc.findIndex((item) => item.startsWith(`${group.displayName}:`));

        if (existingGroupIndex !== -1) {
          // If the group.displayName exists, append the new value.displayName
          const [key, existingValues] = acc[existingGroupIndex].split(': ');
          const updatedValues = `${existingValues}; ${value.displayName}`;

          // Replace the old entry with the updated one
          acc[existingGroupIndex] = `${key}: ${updatedValues}`;
        } else {
          // Otherwise, just add it as a new entry
          acc.push(`${group.displayName}: ${value.displayName}`);
        }
      }
    });
    return acc;
  }, []);

  return {
    products,
    resultCount,
    page,
    attributionToken,
    sortBy,
    query,
    filters,
    grsRequest: parseGRS(grsRequest),
  };
};

const processReferencePricing = (product) => {
  const nowDate = window.vsearch?.nowDate || Math.floor(Date.now() / 1000);
  const {
    pricing: {
      minPrice,
      msrpPrice,
      msrpExpiration,
      msrpPercentOff,
      wasPrice,
      wasPercentOff,
      comparePrice,
      compareExpiration,
      comparePercentOff,
      flashSaleFixedDiscount,
      flashSaleDiscountPercentage,
    },
  } = product;

  // Helper to validate and calculate reference pricing
  const calculateReferencePrice = (price, percentOff, expiration, requiresExpiration) => {
    if (price && percentOff && percentOff >= 3 && percentOff <= 80) {
      if (!requiresExpiration || (expiration && nowDate < Math.floor(new Date(expiration).getTime() / 1000))) {
        return parseFloat(price) * 100; // Convert to cents
      }
    }
    return null;
  };

  // Determine finalComparePrice based on priority
  const finalComparePrice =
    calculateReferencePrice(comparePrice, comparePercentOff, compareExpiration, true) ||
    calculateReferencePrice(msrpPrice, msrpPercentOff, msrpExpiration, true) ||
    calculateReferencePrice(wasPrice, wasPercentOff, null, false) ||
    0;

  // Determine variantPrice with flash sale adjustments
  let variantPrice = parseFloat(minPrice) * 100; // Base price in cents
  if (flashSaleFixedDiscount) {
    variantPrice = parseFloat(flashSaleFixedDiscount) * 100; // Fixed price in cents
  } else if (flashSaleDiscountPercentage) {
    const discount = (flashSaleDiscountPercentage / 100) * variantPrice;
    variantPrice = Math.ceil(variantPrice - discount); // Apply percentage discount
  }

  // Return results
  return {
    price: variantPrice / 100, // Convert back to dollars
    compare_price: finalComparePrice <= variantPrice ? null : finalComparePrice / 100, // Convert back to dollars
  };
};

document.addEventListener('on:product-listing:change', (event) => {
  const { products, page, attributionToken, sortBy, query, filters, grsRequest } = remapData({ ...event.detail });
  const items = products.map((p) => ({
    id: p.id,
    byon_id: p.metafields?.productId?.value || null,
    product_name: p.title,
    sku: p.sku,
    variant_id: p.variant_id,
    variant_name: p.variant_title,
    is_osp: p.isOsp,
    ...processReferencePricing(p)
  }));
  const analyticsData = {
    id: attributionToken || '',
    page_number: page,
    sort_by: sortBy?.displayName,
    filters,
    items,
    grs_filter: grsRequest?.filter || null,
    grs_categories: grsRequest?.pageCategories || null
  };
  if (query || window.vsearch.page_type !== 'collection') {
    analyticsData['search_term'] = query || '';
    if (Shopify.theme.role == 'main') {
      Shopify.analytics.publish('vsearch_search_submitted', { ...analyticsData });
    } else {
      console.log('vsearch_search_submitted', { ...analyticsData });
    }
  } else {
    analyticsData['item_list_name'] = window.vsearch.collection_title;
    if (Shopify.theme.role == 'main') {
      Shopify.analytics.publish('vsearch_collection_viewed', { ...analyticsData });
    } else {
      console.log('vsearch_collection_viewed', { ...analyticsData });
    }
  }

  // window.dataLayer.push(analyticsData);
  // console.log('Intercepted fetch data from Overstock API:', analyticsData);
});

if (window.vsearch.page_type == 'collection' || window.vsearch.page_type == 'search') {
  document.addEventListener('DOMContentLoaded', updateMetaTagsOnCondition);

  // Function to get all parameter values from URL
  function getAllParameterValues() {
    const urlParams = new URLSearchParams(window.location.search);
    let totalValues = 0;
    urlParams.forEach((values, param) => {
      if (!(param == 'selectedSort' || param == 'page')) {
        try {
          const decodedValues = decodeURIComponent(values);
          const arrayValues = JSON.parse(decodedValues);
          if (Array.isArray(arrayValues)) {
            totalValues += arrayValues.length;
          }
        } catch (e) {
          // console.error('Error parsing parameter values:', e);
        }
      }
    });

    return totalValues;
  }

  // Function to create or retrieve a meta tag
  function getOrCreateMetaTag() {
    let metaTag = document.querySelector('meta[name="robots"]');

    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.id = 'robots-meta';
      metaTag.name = 'robots';
      document.head.appendChild(metaTag);
    }

    return metaTag;
  }

  // Function to update meta tags based on condition
  function updateMetaTagsOnCondition(event) {
    const metaTag = getOrCreateMetaTag();
    const totalValues = window.vsearch.page_type == 'search' ? 4 : getAllParameterValues();
    const condition = totalValues >= 3;

    metaTag.setAttribute('content', condition ? 'noindex, nofollow' : 'index, follow');
    if (window.vsearch.page_type == 'search') {
      if (event.detail) {
        const { searchQuery, resultCount } = event.detail;
        if (searchQuery?.productSearchQuery?.searchParameters?.keywords) {
          document.title = `Search: ${resultCount} results found for "${searchQuery.productSearchQuery.searchParameters.keywords}" - Overstock`;
        }
      }
    }
  }

  document.addEventListener('on:product-listing:change', updateMetaTagsOnCondition);
}

document.addEventListener('on:product-listing:change', (event) => {
  if (!window.subcollection_carousel) return; // don't do anything if we don't have the subcollection
  try {
    const { taxonomyFacets, selectedFacets, searchQuery } = event.detail;
    const carousel = document.getElementById(window.subcollection_carousel);
    const flickity = carousel.flickity;
    const taxIds = taxonomyFacets.map((item) => item.taxonomyId);
    const cards = Array.from(carousel.carousel.querySelectorAll('.grid-item[data-taxonomy-id]'));
    cards.forEach((card) => {
      const cardTaxId = card.getAttribute('data-taxonomy-id');
      // Check if the card's taxId is in the taxIds array
      if (taxIds.includes(cardTaxId) || ( selectedFacets.length < 1 && !searchQuery?.productSearchQuery?.restrictions?.specialEvent)) {
        // Remove the "hidden" attribute if the taxId is in the array
        card.removeAttribute('hidden');
      } else {
        // Add the "hidden" attribute if the taxId is not in the array
        card.setAttribute('hidden', 'true');
      }
      flickity.reloadCells();
      flickity.resize();
    });
  } catch (error) {
    console.log(error);
  }
});

const header = document.querySelector('h1.collection-banner__heading');
const originalHeaderText = header && header.innerText;
const container = document.querySelector('.collection-banner__content');
const description = document.createElement('div');
description.classList.add('rte', 'mb-4');
description.innerHTML = '<p>Overstock has negotiated with select factories to provide the following deals for you:</p>';
let discountType = '';

document.addEventListener('on:product-listing:change', (event) => {
  if (header || container) {
    const specialEvent = event?.detail?.searchQuery?.productSearchQuery?.restrictions?.specialEvent;
    const selectedFacets = event.detail.selectedFacets;
    const validDiscountType = selectedFacets.some(
      (sf) =>
        sf.displayName === 'Discount Type' &&
        sf.values.some(
          (value) =>
            value.displayName === 'Factory Direct' ||
            value.displayName === 'Top Deals' ||
            value.displayName === 'Liquidation',
        ),
    );
    const factoyDirect = selectedFacets.some(
      (sf) => sf.displayName === 'Discount Type' && sf.values.some((value) => value.displayName === 'Factory Direct'),
    );
    const discountTypeIsSelected = selectedFacets.some((sf) => sf.displayName === 'Discount Type');
    if (discountTypeIsSelected) {
      if (
        discountType == '' ||
        !selectedFacets.some(
          (sf) => sf.displayName === 'Discount Type' && sf.values.some((value) => value.displayName === discountType),
        )
      )
        discountType = selectedFacets.find((sf) => sf.displayName === 'Discount Type').values[0].displayName;
    } else if (specialEvent) {
      discountType = 'Doorbusters';
    } else discountType = '';
    if (discountType == 'Liquidation') {
      discountType = 'Flash Price Drops'
    }
    if (header) {
      header.innerText =
        validDiscountType || specialEvent ? `${discountType} ${originalHeaderText}` : originalHeaderText;
    }
    if (container) {
      factoyDirect
        ? container.append(description)
        : container.contains(description)
          ? container.removeChild(description)
          : '';
    }
  }
});
